var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import RootSearch from './RootSearch';
import Menu from './Menu';
import IconButton from './IconButton';
var initialState = {
    search: false,
    administration: false,
    insights: false,
    createItem: false,
    apps: false,
    feeds: false,
    notifications: false,
    profile: false,
};
var iconSize = 24;
var iconColor = '#656565';
export default function WorkBar(_a) {
    var logo = _a.logo, data = _a.data, _b = _a.className, className = _b === void 0 ? '' : _b;
    var _c = React.useState(initialState), state = _c[0], setState = _c[1];
    var toggle = function (name, value) {
        var _a;
        setState(__assign(__assign({}, state), (_a = {}, _a[name] = value, _a)));
    };
    return (React.createElement("div", { className: "madonna-workbar " + className },
        logo || null,
        React.createElement("div", { className: "right-panel" },
            React.createElement(RootSearch, { open: state.search, setOpen: function (open) { toggle('search', open); }, icon: {
                    icon: 'search',
                    color: iconColor
                } }),
            React.createElement(IconButton, { icon: {
                    icon: 'settings_outline',
                    useIcomoon: true,
                    size: iconSize,
                    color: iconColor
                }, label: "settings" }),
            React.createElement(Menu, { open: state.insights, setOpen: function (open) { toggle('insights', open); }, options: data.insights, iconButton: {
                    icon: {
                        icon: 'trending_up',
                        color: iconColor
                    },
                    label: 'insights'
                } }),
            React.createElement(Menu, { open: state.createItem, setOpen: function (open) { toggle('createItem', open); }, options: data.createItem, iconButton: {
                    icon: {
                        icon: 'add',
                        color: iconColor
                    },
                    label: 'create item'
                } }),
            React.createElement(Menu, { open: state.apps, setOpen: function (open) { toggle('apps', open); }, content: data.apps, iconButton: {
                    icon: {
                        icon: 'apps',
                        color: iconColor
                    },
                    label: 'apps'
                } }),
            React.createElement(IconButton, { icon: {
                    icon: 'feeds',
                    useIcomoon: true,
                    size: iconSize,
                    color: iconColor
                }, label: "feeds" }),
            React.createElement(IconButton, { icon: {
                    icon: 'notifications_none',
                    color: iconColor
                }, label: "feeds" }),
            React.createElement(IconButton, { icon: {
                    icon: 'person_outline',
                    color: iconColor
                }, onChange: function () { toggle('profile', true); } }))));
}
//# sourceMappingURL=WorkBar.js.map